import { orderBy, query, where } from "firebase/firestore";
import { getAppsCollRef } from "../../../firebase/applications/getAppsCollRef";

const getAllClientApplications = (clientId, authorizedUserId, role ) => {
  // оператор, если назначен, должен просматривать все заявки клиента, даже завершенные другими визовиками.
  const constraints = [
    where('isCreated', '==', true),
    where('UID', '==', clientId),
    orderBy("createdAt", "desc"),
  ]

  // if (role === 'operator') constraints.push(where('preparedInformation.assignedTo', '==', authorizedUserId));

  return query(getAppsCollRef(), ...constraints);
};

export default getAllClientApplications;
